import CheckBoxIcon from "@mui/icons-material/CheckBox"
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank"
import { Checkbox, TextField } from "@mui/material"
import Autocomplete from "@mui/material/Autocomplete"
import CircularProgress from "@mui/material/CircularProgress"
import { Fragment } from "react"

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />
const checkedIcon = <CheckBoxIcon fontSize="small" />
/**
 * @typedef {Object} InputAutocompleteProps
 * @property {number | number[]} value - Valor seleccionado (único o múltiple).
 * @property {boolean} [disabled] - Si está `true`, el componente estará deshabilitado. Valor por defecto: `false`.
 * @property {boolean} [fullWidth] - Si está `true`, el componente ocupa todo el ancho. Valor por defecto: `true`.
 * @property {string} [minWidth] - Ancho mínimo aplicado al componente (por ejemplo, `"200px"`).
 * @property {boolean} [loading] - Muestra un indicador de carga si es `true`. Valor por defecto: `false`.
 * @property {Array<Object>} [options] - Arreglo de objetos con las opciones a mostrar. Valor por defecto: `[]`.
 * @property {string} [optionsLabel] - Nombre de la propiedad del objeto `options` que se usará como etiqueta. Valor por defecto: `"description"`.
 * @property {boolean} [multiple] - Si permite seleccionar múltiples valores. Valor por defecto: `true`.
 * @property {string} [label] - Etiqueta del campo (placeholder o título).
 * @property {(option: Object) => React.ReactNode} [renderOption] - Función para personalizar cómo se renderiza cada opción.
 * @property {Function} [onChange] - Función que se ejecuta cuando se cambia el valor seleccionado.
 * @property {object|int|array} [value] -valores del  .
 * @property {Function} [setValue] - Función que se ejecuta cuando se cambia el valor seleccionado.
 *
 *
 */

/**
 * Componente Autocomplete para seleccionar áreas u otras entidades.
 *
 * @param {InputAutocompleteProps} props - Propiedades del componente.
 * @returns {JSX.Element}
 */
const InputAutocomplete = (props) => {
	const {
		label = "",
		optionsLabel = "description",
		multiple = false,
		loading = false,
		setValue,
		fullWidth = true,
		...propsAutocomplete
	} = props

	const onChange = (event, newValue) => {
		if (typeof setValue === "function") {
			if (multiple) {
				setValue(newValue.map((item) => item?.id))
			} else {
				setValue(newValue)
			}
		}
	}

	return (
		<Autocomplete
			{...{
				loading,
				multiple,
				style: { minWidth: props.minWidth },
				getOptionLabel: (option) => option[optionsLabel],
				onChange,
				disableCloseOnSelect: multiple,
				fullWidth,
				...propsAutocomplete,
				renderInput: (params) => (
					<TextField
						{...params}
						label={label}
						InputProps={{
							...params.InputProps,
							endAdornment: (
								<Fragment>
									{loading ? <CircularProgress color="inherit" size={20} /> : null}
									{params.InputProps.endAdornment}
								</Fragment>
							),
						}}
					/>
				),
			}}
		/>
	)
}
export default InputAutocomplete

export const RenderOptionCheckbox = (props, option, { selected }) => {
	const { key, ...optionProps } = props
	return (
		<li key={key} {...optionProps}>
			<Checkbox
				icon={icon}
				checkedIcon={checkedIcon}
				style={{ marginRight: 8 }}
				checked={selected}
			/>
			{option.name}
		</li>
	)
}
